<template>
  <div class="container-fluid kanban-page">
    <div class="row d-flex h-100">
      <div class="col-lg-12 d-flex flex-column">
        <card class="card-kanban flex-grow-1 d-flex flex-column">
          <kanban-view></kanban-view>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/pages/Layout/LoadingMainPanel";

const KanbanView = () => ({
  component: import('./Bookings/Kanban/KanbanView.vue'),
  loading: Loading,
  delay: 100
});

export default {
  name: "KanbanPage",
  components: {
    KanbanView
  }
}
</script>

<style scoped>
.kanban-page {
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
}

.kanban-page .row {
  flex: 1;
  min-height: 0;
}

.kanban-page .col-lg-12 {
  height: 100%;
}

.card-kanban {
  margin-bottom: 0;
  height: 100%;
}

.card-kanban > :deep(.card-body) {
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

.card-kanban :deep(.kanban-view) {
  height: 100%;
  flex: 1;
}

/* Below 992px the board lays out at its natural height and the page scrolls (OTC-2955) */
@media (max-width: 991.98px) {
  .kanban-page,
  .kanban-page .col-lg-12,
  .card-kanban,
  .card-kanban > :deep(.card-body),
  .card-kanban :deep(.kanban-view) {
    height: auto;
  }
  /* The row carries Bootstrap's h-100 (height: 100% !important) */
  .kanban-page .row {
    flex: none;
    height: auto !important;
  }
}
</style>

<style lang="scss">
.white-content .card.card-kanban:not(.card-white) {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
}
</style>
